export { default } from './wrapperValue.js'



//////////////////
// WEBPACK FOOTER
// /Users/abonnal/Dev/jean-louis-david.lan/web/app/themes/jld/node_modules/lodash-es/value.js
// module id = 737
// module chunks = 0